import Alpine from "alpinejs"
import { on } from "../libraries/utils"

const cookieControl = {
    show() {
        window.tarteaucitron?.userInterface?.openPanel()
    },
}

Alpine.store("cookies", cookieControl)

on(
    ".js-open-orejime, .js-open-tarteaucitron, .js-open-cookies",
    "click",
    (e) => {
        e.preventDefault()
        cookieControl.show()
    }
)
